import { ProfileProvider } from "./providers/ProfileProvider";
import { SeedProvider } from "./providers/SeedProvider";
import { WorkspaceProvider } from "./providers/WorkspaceProvider";
import { ToastHost } from "@/shell/ToastHost";
import { TraceProvider } from "@/shell/TraceProvider";
import { RoleGuideProvider } from "@/shell/RoleGuideProvider";
import { AppRoutes } from "./routes";

export function App() {
  return (
    <SeedProvider>
      <ProfileProvider>
        <WorkspaceProvider>
          <RoleGuideProvider>
            <TraceProvider>
              <AppRoutes />
            </TraceProvider>
          </RoleGuideProvider>
          <ToastHost />
        </WorkspaceProvider>
      </ProfileProvider>
    </SeedProvider>
  );
}
